import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20breathtaking%20artistic%20sunrise%20landscape%20with%20soft%20golden%20and%20rose%20light%20spreading%20across%20a%20calm%20ocean%20horizon%20with%20gentle%20waves%20and%20delicate%20mist%20ethereal%20and%20romantic%20atmosphere%20warm%20cream%20amber%20and%20soft%20coral%20tones%20fine%20art%20photography%20with%20dreamy%20soft%20focus%20and%20expansive%20composition&width=1800&height=900&seq=hero-bg-main-01&orientation=landscape"
          alt="狠狠爱 - 爱得深沉，爱得彻底"
          className="w-full h-full object-cover object-top"
          title="狠狠爱——爱得深沉，爱得彻底"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 mb-6 leading-tight">
          狠狠爱
        </h1>
        <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          不顾一切、全力以赴的爱。无论是爱自己、爱家人还是爱伴侣，
          把最真实的情感毫无保留地释放，让每一份情感都燃烧得更有意义。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/love-yourself"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            探索爱的世界
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-background-50/20 text-background-50 border border-background-50/30 px-8 py-3.5 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors duration-200 whitespace-nowrap"
          >
            了解我们
          </Link>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <span className="w-8 h-8 flex items-center justify-center animate-bounce text-background-50/60">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}